export default __webpack_public_path__ + "088dec620789b6e0b321536b16903a37.obj";